import * as React from 'react';

// progress
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

const HidableProgress = props => {
    const styles = {
        logo: {
          height: 70,
          marginLeft: 0,
          marginTop: '0.8%',
          width: 150,
        },
    }
    function HProgress(prop) {
        // const visible = prop.vi;
        if (props.visible) {
          return <Progress percent={props.uploadprogress} status={props.uploadstatus} />;
        }
        return <div/>;
      }
    return (  
        <HProgress/>
    )
  };

  export default HidableProgress;


// WEBPACK FOOTER //
// ./src/common/hidableProgress.Component.tsx